import {SourceType} from './Filter';

export interface Result {
    records: Record[],
    total: number,
    facets: Facet
}

export interface Record {
    id: string,
    title: string,
    source: string,
    text: string,
    url: string,
    likes: number,
    views: number,
    updatedAt: string
}

export type Facet = {
    [key in SourceType]: number;
};

export const emptyResult: Result = {
    records: [],
    total: 0,
    facets: {
        community: 0,
        documentation: 0,
        partner_documentation: 0,
        knowledge_base: 0,
        release_notes: 0,
        drafts: 0
    }
};
